import React, { useState } from "react";
import Contacts from "@/pages/contacts";

const Newzealandskilledmigrationvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/newzelands.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          
        </div>
      </div>
      <div className="px-4 mt-10 text-3xl text-center justify-center font-bold text-[#011473] drop-shadow-md sm:text-2xl md:text-3xl md:ml-10 lg:ml-20 lg:w-3/4">
  Your Gateway to a New Life: New Zealand Skilled Visa
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/newzeland.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-full h-full rounded object-cover"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-2 lg:w-2/3  ">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
             <a className="text-black font-bold"> Skilled Migrant Category Resident Visa:</a> A points-based visa
              enabling you to live and work in New Zealand permanently. Points
              are based on age, qualifications, work experience and
              employability.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Age Limit:</a> Below 56 years Health and Character: Must
              meet health, character and English proficiency standards -
              Points Requirement: Minimum of 160 points
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Essential Skills Work Visa:</a> Designed for individuals with a
              valid job offer from a New Zealand employer. This visa allows
              temporary work based on the offered role.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Job Offer:</a> A valid offer from a New Zealand employer -
              Skill Match: Role must align with your skills and experience
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Talent (Accredited Employer) Work Visa:</a> For individuals with
              employment offers from accredited employers, this visa provides a
              pathway to residency after two years of work.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Job Offer:</a> From an accredited employer Salary
              Requirement: Must meet the minimum salary threshold
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Long Term Skill Shortage List Work Visa:</a> Available to those
              with skills listed on the Long Term Skill Shortage List. This visa
              offers an opportunity to work and later apply for permanent
              residency.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold"> Shortage List Match:</a> Your occupation must be listed -
              Relevant Experience: Must have the required qualifications and
              experience
            </span>
          </div>
        </div>
      </div>

      <div className="px-4 md:m-10">
  <p className="mb-5 text-xl font-bold text-[#011473] sm:text-2xl lg:text-left lg:ml-10">
    Why Choose Visa World for Your New Zealand Visa Application?
  </p>
  <div className="mb-20 space-y-6 text-left sm:text-center lg:text-left lg:ml-10">
    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Expert Knowledge:</a> Comprehensive understanding of New Zealand immigration laws.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> End-to-End Support:</a> Assistance from eligibility assessment to application submission.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Tailored Advice:</a> Customized solutions to fit your goals.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
        Begin your Skilled Migration journey to New Zealand today with Visa World—your trusted partner in turning dreams into reality!
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
        Contact us now to get started!
      </span>
    </div>
  </div>
</div>


<div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Why Opt for the New Zealand Skilled Migration Visa?</strong>
        <br />
        - <strong>Pathway to Permanent Residency:</strong> Open doors to a stable future with the opportunity to attain permanent residency in New Zealand.
        <br />
        - <strong>Sought-After Professions:</strong> Tap into lucrative career prospects in industries experiencing significant demand.
        <br />
        - <strong>Exceptional Lifestyle:</strong> Benefit from a superior quality of life, world-class healthcare and top-tier education.
        <br />
        - <strong>Family-Friendly Opportunities:</strong> Relocate with your loved ones and embrace the vibrant Kiwi lifestyle together.
        <br />
        This visa is your gateway to a fulfilling career and a new chapter in one of the world’s most desirable destinations.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Why Opt for the New Zealand Skilled Migration Visa? Learn More
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>


      <Contacts />
    </>
  );
};

export default Newzealandskilledmigrationvisa;
